import { getGroupPermissionFactory, PermissionEnum } from '../../../common';
import { PaymentConfigurationsPermissions } from './payment-management.payment-configurations.permissions';

export class HyperpayConfigurationsPermissions {
  static GroupName = `${PaymentConfigurationsPermissions.GroupName}.HyperpayPaymentConfigurations`;

  static getPermissions = getGroupPermissionFactory(HyperpayConfigurationsPermissions.GroupName);

  static Permissions = {
    Create: HyperpayConfigurationsPermissions.getPermissions(PermissionEnum.CREATE),
    Update: HyperpayConfigurationsPermissions.getPermissions(PermissionEnum.UPDATE),
  };
}